// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import ScreenreaderOnly from '../internal/components/screenreader-only';
import InternalSkeleton from '../skeleton/internal';
import { TableBodyCell } from './body-cell';
import { getColumnKey } from './utils';
import styles from './styles.css.js';
const noop = () => { };
export function SkeletonRows({ count, totalColumnsCount, loadingText, hasSelection, hasFooter, stickyState, tableRole, ariaLabels, cellVerticalAlign, computedVariant, visibleColumnDefinitions, wrapLines, resizableColumns, colIndexOffset, renderCell, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", { "aria-hidden": "false" },
            React.createElement("td", { colSpan: totalColumnsCount, className: styles['skeleton-loading-cell'] },
                React.createElement(ScreenreaderOnly, null, loadingText))),
        Array.from({ length: count }, (_, i) => {
            return (React.createElement("tr", { key: `skeleton-row-${i}`, className: styles.row, "aria-hidden": "true" },
                hasSelection && React.createElement("td", { className: styles['selection-control'] }),
                visibleColumnDefinitions.map((column, colIndex) => {
                    var _a, _b;
                    return (React.createElement(TableBodyCell, { key: `skeleton-${getColumnKey(column, colIndex)}`, isSelected: false, isPrevSelected: false, isNextSelected: false, hasSelection: hasSelection, hasFooter: hasFooter, stickyState: stickyState, tableRole: tableRole, resizableStyle: {
                            width: column.width,
                            minWidth: column.minWidth,
                            maxWidth: column.maxWidth,
                        }, ariaLabels: ariaLabels, column: {
                            ...column,
                            cell: () => {
                                const customSkeleton = renderCell === null || renderCell === void 0 ? void 0 : renderCell(column);
                                return customSkeleton === undefined ? (React.createElement(InternalSkeleton, { variant: "dynamic", tagOverride: "span" })) : (customSkeleton);
                            },
                        }, item: {}, wrapLines: wrapLines, isEditable: false, isEditing: false, isRowHeader: column.isRowHeader, resizableColumns: resizableColumns, onEditStart: noop, onEditEnd: noop, columnId: (_a = column.id) !== null && _a !== void 0 ? _a : colIndex, colIndex: colIndex + colIndexOffset, verticalAlign: (_b = column.verticalAlign) !== null && _b !== void 0 ? _b : cellVerticalAlign, tableVariant: computedVariant }));
                })));
        })));
}
//# sourceMappingURL=skeleton-rows.js.map